import { useTheme } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useLocation } from 'react-router';
import { ROUTES } from '../../constants/routes';
import { isSmallScreenState } from '../../state/UIState';
import { PageHeader } from '../layout/PageHeader';
import { ContentWrapper } from '../layout/styled';
import { IssuedTimesheetsTable } from './components/IssuedTimesheetsTable';

export const IssuedTimesheets = () => {
  const { colors } = useTheme();
  const isSmallScreen = useAtomValue(isSmallScreenState);
  const { pathname } = useLocation();

  // Title and parent crumb follow the ROUTE, not role precedence: /issued-timesheets is the Proxy
  // view, /pending-timesheets is the Submitter view. A user holding both roles must see the correct
  // header on each page instead of always getting the Submitter title.
  const isProxyIssuedView = pathname.includes(ROUTES.ISSUED_TIMESHEETS);
  const pageTitle = isProxyIssuedView ? 'Issued Timesheets' : 'Pending Timesheets';
  const allTimesheetsUrl = isProxyIssuedView
    ? `/${ROUTES.PROXY_ALL_TIMESHEETS}`
    : `/${ROUTES.ALL_TIMESHEETS}`;

  return (
    <>
      <PageHeader
        title={pageTitle}
        description={isProxyIssuedView ? 'Fill and submit issued timesheets' : ''}
        breadcrumbs={[
          {
            title: 'All timesheet',
            url: allTimesheetsUrl,
            color: colors.textAccent.default,
          },
          {
            title: pageTitle,
            // url: `/${ROUTES.ISSUED_TIMESHEETS}`,
          },
        ]}
      />
      <ContentWrapper isSmallScreen={isSmallScreen}>
        <IssuedTimesheetsTable />
      </ContentWrapper>
    </>
  );
};
